<template>
  <div>
    <login />
    <router-view />
  </div>
</template>

<script>
import { Login } from "@/modules/auth";
export default {
  name: "home",
  components: {
    Login
  }
};
</script>

<style lang="scss" scoped></style>
